<template>
<!-- 常见问题 -->
    <div>
        <div class="headerNav">
            <div class="headerNavYinShiLogo">
                <router-link to='/homePage'><img src="../assets/img/homePage/gongsi_logo.png" alt="" /></router-link>
            </div>
            <div class="headerNavPhoneEmail">
                <div class="navPhone">
                <img src="../assets/img/homePage/dingbu_dianhua.png" alt="" />
                <span>86 (021)-36511001</span>
                </div>
                <div>
                <img src="../assets/img/homePage/dingbu_youxiang.png" class="dingbu_youxiang" alt="" />
                <span>2629387311@qq.com</span>
                </div>
            </div>
        </div>
        <!-- 常见问题  -->
        <div class="homePageLarge">
            <!--  -->
            <div class="crumbs">
                <span class="hoverColor"><router-link to='/homePage'>返回首页</router-link></span>
                <span>常见问题</span>
            </div>
            <div class="problemAll">
                <div class="problem" v-for="(item,index) in tableData" :key="index">
                    <p class="title">{{item.introduction}}</p>
                    <div class="content">{{item.question}}</div>
                    
                    <!-- <div class="contentBtn">阅读全文 > ></div> -->
                </div>
                <div class="problem" v-if="tableData.length <= 0">
                    <p class="title" style="color:red;">暂无数据！</p>
                    <div class="content">......</div>
                    
                    <!-- <div class="contentBtn">阅读全文 > ></div> -->
                </div>
            </div>
            <!-- <img loading="lazy" src="@/assets/img/homePage/gongsishouye_02.jpg" alt=""> -->
        </div>
        <Footer></Footer>

    </div>
</template>

<script>
import {listFaq} from '@/api'
import { mapMutations } from 'vuex'
import Footer from '@/components/Footer.vue'
export default {
    name: 'YinshiOffcialwebsiteCommonProblem',

    data() {
        return {
            tableData:[]
        };
    },

    mounted() {
        
    },
    components:{
        Footer,
    },

    methods: {
        ...mapMutations(['GoTop']),
        async selectTableData(){
            let res = await listFaq({page:1,pageSize:999});
            this.tableData = res.data
        },
    },    
    created(){
        this.$store.state.currentRouter = this.$route.path  //获取当前页面路由
        this.GoTop()
        this.selectTableData()
    }
};
</script>

<style lang="scss" scoped>
// 头部 logo和电话及邮箱
.headerNav {
  //整个div
  padding: 18px 270px;
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 999;
  background: #fff;
    //logo
  .headerNavYinShiLogo {
    img {
      width: 167px;
      height: 45px;
    }
  }
  //电话及邮箱
  .headerNavPhoneEmail {
    display: flex;
    div {
      display: flex;
      align-items: center;
      margin-top: -5px;
      img {
        width: 15px; 
        height: 15px; 
        margin-top: 8px; 
        padding: 0px 5px;
      }
      .dingbu_youxiang{
        width: 17px !important; 
      }
      span {
        height: 13px;
        font-size: 16px;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        font-weight: 400;
        text-align: center;
        color: #444444;
      }
    }
    .navPhone {
      margin-right: 55px;
    }
  }
}
// 常见问题
.homePageLarge{
    // 常见问题面包屑
    .crumbs{
        background: #eeeeee;
        padding:10.5px 270px;
        font-size: 16px;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        font-weight: 400;
        span:nth-child(1){
            color:#666666;
            padding:0px 11px;
            border-right:1px solid #E1E1E1;
            cursor: pointer;
            margin-left: -11px;
        }
        a{
            transition: .2s;
        }
        .hoverColor a:hover{
            color:#7492D7 !important;
        }
        span:nth-child(2){
            color:#666666;
            padding:0px 11px;
        }
    }
    // 问题
    .problemAll{
        padding: 0px 270px;
        margin-top: 20px;
        .problem{
            .title{
                font-size: 16px;
                font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                font-weight: 700;
                color: #444444;
            }
            .content{
                font-size: 16px;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                font-weight: 400;
                text-align: left;
                color: #666666;
                line-height: 32px;
                margin-top: 20px;
            }
            .contentBtn{
                width: 121px;
                height: 38px;
                background: #3b589a;
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                color:#fff;
                margin-top: 30px;
            }
            padding:50px 0px;
            border-bottom:1px solid #D0D0D0;
        }
        .problem:last-child{ 
            padding:50px 0px 70px 0px;
            border-bottom:0px solid #D0D0D0;

        }
    }
}
</style>